import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=7547052c&scoped=true&"
import script from "./Past.vue?vue&type=script&lang=js&"
export * from "./Past.vue?vue&type=script&lang=js&"
import style0 from "./Past.vue?vue&type=style&index=0&id=7547052c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7547052c",
  null
  
)

export default component.exports